const $backToTopBtn = $('#back-to-top');
if ($backToTopBtn.length) {
  const scrollTrigger = 100; // px
  const backToTop = () => {
      const scrollTop = $(window).scrollTop();
      if (scrollTop > scrollTrigger) {
        $backToTopBtn.addClass('show');
      } else {
        $backToTopBtn.removeClass('show');
      }
    };

  backToTop();

  $(window).on('scroll', function () {
    backToTop();
  });

  $backToTopBtn.on('click', function (e) {
    e.preventDefault();
    $('html,body').animate({
      scrollTop: 0
    }, 500)
  });
}


// WEBPACK FOOTER //
// ./src/js/back-to-top.js